import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PatientFinderService } from '../../../patient-finder/patient-finder.service';
import { PatientDeviceDataModel } from '../../../models/enroll-patient-device-data.model';
import { HelperService, IdentifierService, patientData } from 'merlin-core';
import { LocalizationService } from 'src/core/utilitites/localization.service';
import { SpinnerService } from 'merlin-library';

@Component({
    selector: 'app-ins-information-dialog',
    templateUrl: './ins-information-dialog.component.html',
    styleUrls: ['./ins-information-dialog.component.scss'],
    standalone: false
})
export class InsInformationDialogComponent implements OnInit {
  isClickConfirm: boolean;
  patRes: any;
  isInsNumber: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<InsInformationDialogComponent>,
    public identifierService: IdentifierService,
    private localizationService: LocalizationService,
  ) { }

  ngOnInit(): void {
    this.patRes = this.data.patientData;
    this.isInsNumber = this.data.patientData?.isValidInsNumber;    
  }

  getGender() {
    let patChamb = this.patRes.dropdowns?.genderCodes
      .filter((code) => {
        return code.codeId == this.patRes.patient?.genderCd;
      });
    if (!patChamb) {
      return '';
    } else {
      const genderText = this.formatDDString(patChamb[0]);
      return this.translate(genderText);
    }
  }
  formatDDString(ddObj: any) {
    if (ddObj) {
      return this.localizationService.generateLocalizedStr(
        'data.Code.' + ddObj.qualifier + '.Code_Desc.' + ddObj.code
      );
    } else {
      return '';
    }
  }
  translate(key: string) {
    return this.localizationService.generateLocalizedStr(key);
  }

  confirm() {
    this.isClickConfirm =true;
    this.dialogRef.close({
      isClickConfirm: this.isClickConfirm,
      patientData:this.patRes
    })
  }
  cancel() {
    this.isClickConfirm = false;
    this.dialogRef.close({
      isClickConfirm: this.isClickConfirm,
      patientData:{}
    })
  }
}
